// https://ethoslife.atlassian.net/browse/GC-1905
// https://app.optimizely.com/v2/projects/15340850549/features/23210951426
export const RISK_ID = 'riskIdCMS'

interface Feature {
  name: string
  variables?: Record<string, unknown>
  ruleKeys?: any
  audiences?: Array<string>
  cookieName?: string
  variations?: Record<string, string>
}

export const LIVING_EXPENSES = {
  name: 'monthly_and_children_gc-3569',
  variations: {
    treatment1: 'treatment1',
    treatment2: 'treatment2',
    off: 'off',
  },
}

export const BEST_MONEY_COBRANDED_HEADER = {
  name: 'best_money_cobranded_header_gc-2392',
  cookieName: 'BEST-MONEY-HEADER-FEATURE',
  audiences: ['/life/quick-online-quote/'],
  variations: {
    on: 'on',
    off: 'off',
  },
}

export const CREDIT_KARMA_COBRANDED_HEADER = {
  name: 'credit_karma_cobranded_header_gc-3082',
  cookieName: 'CREDIT-KARMA-HEADER-FEATURE',
  audiences: ['/life/credit-karma-members/'],
  variations: {
    on: 'on',
    off: 'off',
  },
  ruleKeys: {
    off: 'credit_karma_cobranded_header_gc-3082-off',
    on: 'credit_karma_cobranded_header_gc-3082-on',
  },
}

export const PAID_LANDERS_UPDATE = {
  name: 'gc-3933_paid_landers_update',
  variations: {
    treatment1: 'treatment1',
    treatment2: 'treatment2',
    treatment3: 'treatment3',
    off: 'off',
  },
  ruleKeys: {
    off: 'gc-3933_paid_landers_update-off',
    on: 'gc-3933_paid_landers_update-on',
  },
}

/**
 * It allows for a controlled rollout and testing of the new analytics framework service
 * https://app.optimizely.com/v2/projects/15340850549/flags/manage/analytics_service_routing/rules/development
 */
export const ANALYTICS_SERVICE_ROUTING = {
  name: 'analytics_service_routing',
  cookieName: 'ANALYTICS-SERVICE-ROUTING',
  /**
   * Control / off will only send events to Segment using the legacy setup
   * Hybrid will send events to both Segment and the analytics service
   * Service will send events to only the analytics service
   */
  variations: {
    off: 'off',
    control: 'control',
    hybrid: 'hybrid',
    service: 'service',
  },
}
